import React from 'react';
import styled from 'styled-components';

import { breakpoints } from 'Components/Theme';
import { Text } from 'Components/Base';

const FixedText = styled(Text)`
  text-align: center;
  font-weight: 900;
  position: absolute;
  /* bottom: 76%; */
  bottom: 78%;

  margin: 0 8px;
  width: calc(100% - 16px);
  /* @media (min-width: ${breakpoints[1]}px) {
    bottom: 78%;
  } */
  @media (min-width: ${breakpoints[2]}px) {
    text-align: left;
    width: auto;
    margin: 0;
    bottom: 63%;
    left: 10.2%;
  }
`;

const FixedTextV1 = styled(FixedText)``;

const FixedTextV2 = styled(FixedText)`
  /* bottom: 72%; */
  bottom: 78%;

  /* @media (min-width: ${breakpoints[1]}px) {
    bottom: 78%;
  } */
  @media (min-width: ${breakpoints[2]}px) {
    bottom: 67%;
  }
`;

const FixedTextV3 = styled(FixedText)`
  /* bottom: 70%; */
    bottom: 60%;

  /* @media (min-width: ${breakpoints[1]}px) {
    bottom: 60%;
  } */
  @media (min-width: ${breakpoints[2]}px) {
    bottom: 64%;
  }
`;

const PrefixText = styled(Text)`
  color: inherit;
  line-height: inherit;
  /* font-size: 180%; */
  /* display: block; */
  /* width: 100%; */

  /* @media (min-width: ${breakpoints[1]}px) { */
    font-size: 100%;
    display: inline-block;
    width: fit-content;
    margin-right: 0.8vw;
  /* } */
`;

const PrefixTextV1 = styled(PrefixText)``;
const PrefixTextV2 = styled(PrefixText)``;
const PrefixTextV3 = styled(PrefixText)`
  /* font-size: 220%; */
  /* @media (min-width: ${breakpoints[1]}px) { */
    display: block;
    width: 100%;
    font-size: 200%;
  /* } */
  @media (min-width: ${breakpoints[2]}px) {
    display: inline-block;
    width: fit-content;
    font-size: 100%;
  }
`;

const getFixedText = variant => {
  switch (variant) {
    case 0:
      return ({ children, ...restProps }) => (
        <FixedTextV1 {...restProps}>
          <PrefixTextV1>อยากติด</PrefixTextV1>
          {children}
        </FixedTextV1>
      );
    case 1:
      return ({ children, ...restProps }) => (
        <FixedTextV2 {...restProps}>
          <PrefixTextV2>อยากเข้า</PrefixTextV2>
          {children}
        </FixedTextV2>
      );
    case 2:
      return ({ children, ...restProps }) => (
        <FixedTextV3 {...restProps}>
          <PrefixTextV3>ทันข่าว</PrefixTextV3>
          {children}
        </FixedTextV3>
      );
    default:
      return ({ children, ...restProps }) => (
        <FixedText {...restProps}>
          <PrefixText>อยากติด</PrefixText>
          {children}
        </FixedText>
      );
  }
};

export default ({ variant, ...restProps }) => {
  const RenderComp = getFixedText(variant);
  return (
    <RenderComp
      color="white"
      // fontSize={['8vw', null, '4.4vw', 36]}
      fontSize={['4.4vw', null, null, 32]}
      lineHeight={1.18}
      fontWeight="bolder"
      {...restProps}
    />
  );
};
